import React from 'react'
import { Switch } from 'antd'
import { injectIntl } from 'react-intl'

import S from './Styles'
import { resolveTimezones, convertTimezoneIANAToUTCFormat } from '../utils/date'

/**
 * Toggle between the device timezone and the browser (local) timezone.
 *
 * Controlled component: `checked` is true when the device timezone is
 * selected, `onChange(checked)` is called when the user toggles.
 * Renders nothing when both timezones are the same.
 */
const TimezoneSwitch = ({ deviceTimeZone, checked, onChange, intl, style }) => {
	const { deviceTimezone, browserTimezone, isDifferent } =
		resolveTimezones(deviceTimeZone)
	if (!isDifferent) {
		return null
	}

	return (
		<span style={{ ...styles.container, ...style }}>
			<span style={styles.label}>
				{intl.formatMessage({ id: 'timezone.label' })}
			</span>
			<Switch
				style={{ ...S.switchOneColor, flexShrink: 0 }}
				checkedChildren={`${intl.formatMessage({ id: 'timezone.device' })} (${convertTimezoneIANAToUTCFormat(deviceTimezone)})`}
				unCheckedChildren={`${intl.formatMessage({ id: 'timezone.local' })} (${convertTimezoneIANAToUTCFormat(browserTimezone)})`}
				checked={checked}
				onChange={onChange}
			/>
		</span>
	)
}

const styles = {
	container: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '8px'
	},
	label: {
		whiteSpace: 'nowrap',
		flexShrink: 0
	}
}

export default injectIntl(TimezoneSwitch)
